/*
  stb-reveal — the scroll reveal for every stb-* section.

  It replaces a per-section inline <script> that could never work: the snippet
  that emitted it renders at the top of a section, so it ran before that
  section's children existed and observed an empty NodeList. The sections whose
  animation defaults to "rise" — the spec strip and the steps — were left at
  opacity:0 forever and shipped as full-height blank bands.

  Two rules this file keeps:

  1. The stylesheet only hides content once THIS file has run. It adds
     `stb-reveal-ready` to <html>; the opacity:0 rule is scoped to that class.
     If this script is blocked, errors, or never parses, nothing is hidden.
  2. Anything already on screen at load is revealed immediately rather than
     waiting for an intersection that has already happened.
*/
(function () {
  var CLS = 'stb-reveal-ready';
  var root = document.documentElement;

  function show(el) { el.classList.add('is-in'); }

  function start() {
    var els = document.querySelectorAll('.stb-reveal:not(.is-in)');
    if (!els.length) return;

    if (!('IntersectionObserver' in window)) {
      // No observer: never hide anything.
      root.classList.remove(CLS);
      Array.prototype.forEach.call(els, show);
      return;
    }

    root.classList.add(CLS);
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { show(e.target); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -10% 0px' });

    Array.prototype.forEach.call(els, function (el) {
      var r = el.getBoundingClientRect();
      // In view, or already scrolled past. `r.bottom > 0` was in this test and
      // excluded everything above the viewport: on a slow phone a visitor can
      // scroll past a section before DOMContentLoaded, and it would then snap
      // to opacity:0 and only return if they scrolled back up.
      if (r.top < (window.innerHeight || 0)) { show(el); return; }
      io.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  // Theme editor: sections are re-rendered without a page load.
  document.addEventListener('shopify:section:load', start);
})();
